let __awaiter =
  (this && this.__awaiter) ||
  function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function(resolve) {
            resolve(value)
          })
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value))
        } catch (e) {
          reject(e)
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value))
        } catch (e) {
          reject(e)
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected)
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next())
    })
  }
import { computeBackdropPosition } from './backdrop'
import { computeDialogPosition } from './dialog'
/**
 * computeTourPositions
 */
function computeTourPositions() {
  return new Promise(resolve =>
    __awaiter(this, void 0, void 0, function*() {
      /**
       * Update overlay position
       */
      this.backdrop.style.display = 'block'
      yield computeBackdropPosition(this)
      /**
       * Update dialog position
       */
      this.dialog.style.display = 'block'
      if (this.options.dialogAnimate && this.isVisible)
        this.dialog.classList.add('animate-position') // add transition class
      yield computeDialogPosition(this)
      if (this.options.dialogAnimate)
        setTimeout(() => {
          this.dialog.classList.remove('animate-position')
        }, 300) // cancel after 300ms css transition complete
      this.isVisible = true
      /**
       * Resize & Scroll
       */
      // Re-compute on resize
      if (!window.onresize)
        window.onresize = () => {
          computeBackdropPosition(this)
          computeDialogPosition(this)
        }
      // Re-compute on resize - dialog only
      if (!window.onscroll)
        window.onscroll = () => {
          computeDialogPosition(this)
        }
      // Match timeout with CSS transition & smooth scroll
      yield setTimeout(() => {
        return resolve(true)
      }, 300)
    })
  )
}
export default computeTourPositions
